<template>
    <div>
        <!-- Show normal content when: not loading AND (maintenance not started OR maintenance already ended) -->
        <div v-if="!loading && (!openSystemMaintenance || closeSystemMaintenance)" class="home-pagex">
            <section v-if="scroll_news" class="event nav-abs p-0 m-0"
                style="border: 2px solid #f9e7d0; background-color:#fdfaf4;">
                <div class="container set-marginx pt-1">
                    <div class="row pt-1">
                        <div class="col-md-12">
                            <marquee scrollamount="3" style="font-size: 17px; font-family: 'kalpurush';">
                                <span onmouseover="this.parentNode.stop()" onmouseout="this.parentNode.start()"
                                    v-html="scroll_news"></span>
                            </marquee>
                        </div>
                    </div>
                </div>
            </section>

            
           
            
            
            <section id="mainPage" class="event about bg bg-img-1 bg-about">
                <!-- <RegistrationCountDown/> -->
                <div class="container">
                    <div v-if="!openCall" class="row justify-content-center">
                        <div class="col-md-10 col-lg-8">
                            <div class="card border-0 shadow-lg" style="border-radius: 24px; background: rgba(255, 255, 255, 0.95);">
                                <div class="card-body text-center py-5">
                                    <h1 class="display-4 fw-bold mb-3" style="color: #16a34a;">
                                        <span>{{ openCallMsg }}</span>
                                    </h1>
                                    <p class="lead text-muted">Please check back later for updates. </p>
                                </div>
                            </div>
                        </div>
                    </div>
        
                    <div v-else class="row justify-content-center">
                        <div class="col-12">
                            <div class="card border-0 shadow-lg" style="border-radius: 24px; background: rgba(255, 255, 255, 0.95);">
                                <div class="card-body p-4 p-md-5">
                                    <div class="row justify-content-center align-items-center" style="display: flex;">
                                        <div v-if="!closeCall" class="col-12 col-sm-6 col-lg-3">
                                            <div class="card h-100 border-primary shadow-sm" style="border-width: 2px; border-radius: 16px; transition: all 0.3s ease;" onmouseover="this.style.transform='translateY(-8px)'; this.style.boxShadow='0 12px 24px rgba(0, 0, 0, 0.15)';" onmouseout="this.style.transform=''; this.style.boxShadow='';">
                                                <div class="card-body text-center d-flex flex-column justify-content-between p-4">
                                                    <h5 class="card-title text-primary fw-bold mb-4" style="font-size: clamp(1rem, 2vw, 1.125rem);">
                                                        New Applicant?
                                                    </h5>
                                                    <button class="btn btn-primary btn-lg w-100" @click="$bvModal.show('registrationModal')" style="border-radius: 12px; font-size: clamp(0.875rem, 1.5vw, 1rem); padding: 0.75rem 1.5rem; font-weight: 600;">
                                                        Register
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-12 col-sm-6 col-lg-3">
                                            <div class="card h-100 border-success shadow-sm" style="border-width: 2px; border-radius: 16px; transition: all 0.3s ease;" onmouseover="this.style.transform='translateY(-8px)'; this.style.boxShadow='0 12px 24px rgba(0, 0, 0, 0.15)';" onmouseout="this.style.transform=''; this.style.boxShadow='';">
                                                <div class="card-body text-center d-flex flex-column justify-content-between p-4">
                                                    <h5 class="card-title text-success fw-bold mb-4" style="font-size: clamp(1rem, 2vw, 1.125rem);">
                                                        Registered Applicant?
                                                    </h5>
                                                    <button class="btn btn-success btn-lg w-100" @click="$bvModal.show('loginModal')" style="border-radius: 12px; font-size: clamp(0.875rem, 1.5vw, 1rem); padding: 0.75rem 1.5rem; font-weight: 600;">
                                                        Log In
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div v-if="!closeCall" class="col-12 col-sm-6 col-lg-3">
                                            <div class="card h-100 border-info shadow-sm" style="border-width: 2px; border-radius: 16px; transition: all 0.3s ease;" onmouseover="this.style.transform='translateY(-8px)'; this.style.boxShadow='0 12px 24px rgba(0, 0, 0, 0.15)';" onmouseout="this.style.transform=''; this.style.boxShadow='';">
                                                <div class="card-body text-center d-flex flex-column justify-content-between p-4">
                                                    <h5 class="card-title text-info fw-bold mb-4" style="font-size: clamp(1rem, 2vw, 1.125rem);">
                                                        GCE / Equivalent
                                                    </h5>
                                                    <router-link to="/gce" class="btn btn-info btn-lg w-100 text-white" target="_blank" style="border-radius: 12px; font-size: clamp(0.875rem, 1.5vw, 1rem); padding: 0.75rem 1.5rem; font-weight: 600; text-decoration: none;">
                                                        Application Portal
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-12 col-sm-6 col-lg-3">
                                            <div class="card h-100 border-danger shadow-sm" style="border-width: 2px; border-radius: 16px; transition: all 0.3s ease;" onmouseover="this.style.transform='translateY(-8px)'; this.style.boxShadow='0 12px 24px rgba(0, 0, 0, 0.15)';" onmouseout="this.style.transform=''; this.style.boxShadow='';">
                                                <div class="card-body text-center d-flex flex-column justify-content-between p-4">
                                                    <h5 class="card-title text-danger fw-bold mb-4" style="font-size: clamp(1rem, 2vw, 1.125rem);">
                                                        Complaint
                                                    </h5>
                                                    <router-link to="/complain" class="btn btn-danger btn-lg w-100" target="_blank" style="border-radius: 12px; font-size: clamp(0.875rem, 1.5vw, 1rem); padding: 0.75rem 1.5rem; font-weight: 600; text-decoration: none;">
                                                        Submit
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row justify-content-center">
                        
                        <div class="col-12">
                            <div class="abouts center-textx mt-5 pt-5" 
                                style="width:100%; background: #ffffff; padding: 40px; border-radius: 16px; box-shadow: 0 6px 25px rgba(0,0,0,0.08);">
                                
                                <div class="format-head-textx text-center mb-4">
                                <h5 class="about-font-header"  style="font-weight: 700; color: #321575; font-size: 2rem; margin-bottom: 16px;">
                                    Important Links
                                </h5>
                                </div>

                                <div class="d-flex flex-wrap justify-content-center gap-4">
                                <router-link to="/prospectus" target="_blank" 
                                            class="btn modern-btn">
                                    প্রসপেক্টাস
                                </router-link>
                                <router-link to="/admission-circular" target="_blank" 
                                            class="btn modern-btn">
                                    ভর্তি বিজ্ঞপ্তি
                                </router-link>
                                <router-link to="/application-process" target="_blank" 
                                            class="btn modern-btn">
                                    আবেদন প্রক্রিয়া
                                </router-link>
                                <router-link to="/general-qualifications" target="_blank" 
                                            class="btn modern-btn">
                                    সাধারণ যোগ্যতা
                                </router-link>
                                <router-link to="/schedule" target="_blank" 
                                            class="btn modern-btn">
                                    সময়সূচী
                                </router-link>
                                <router-link to="/fee-payment-rules" target="_blank" 
                                            class="btn modern-btn">
                                    ফি প্রদানের নিয়মাবলী
                                </router-link>
                                </div>

                            </div>
                        </div> 

                        <div class="col-12 ">
                            <div class="abouts center-textx mt-5 px-5 py-5 bg-white box-shadow" style="width:100%;border-radius: 16px;box-shadow: 0 4px 20px rgba(0,0,0,0.1);">
                                
                                <div class="format-head-textx text-center mb-4">
                                    <h5 class="about-font-header" style="font-weight: 700; color: #321575; font-size: 1.8rem; margin-bottom: 12px;">
                                        Unit-wise Important Dates
                                    </h5>
                                    <p class="text-muted mt-2">
                                        <span class="badge bg-success" style="animation: pulse 2s infinite;">●</span> Application Period Active
                                    </p>
                                </div>

                                <div class="format-sub-text table-responsive" style="border-radius: 12px;">
                                    <table class="table table-hover text-center mb-0" style="font-size: 14px;">
                                        <thead style="background: #f8fafc; color: #475569;">
                                            <tr>
                                                <th scope="col" class="py-3 align-middle" style="font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; font-size: 13px;">Unit</th>
                                                <th scope="col" class="py-3 align-middle" style="font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; font-size: 13px;">Application Start</th>
                                                <th scope="col" class="py-3 align-middle" style="font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; font-size: 13px;">Application End</th>
                                                <th scope="col" class="py-3 align-middle" style="font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; font-size: 13px;">Exam Date</th>
                                            </tr>
                                        </thead>
                                        <tbody style="background: white;">
                                            <tr style="transition: all 0.3s ease; border-bottom: 1px solid #f0f0f0;">
                                                <td class="py-3 align-middle">
                                                    <span class="badge" style="background: #321575; padding: 6px 14px; font-size: 0.9rem; color: white;">A</span>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #059669; font-weight: 500;">
                                                        <strong>{{ openCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #dc2626; font-weight: 500;">
                                                        <strong>{{ closeCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #1e40af; font-weight: 500;">
                                                        <strong>02 January, 2026</strong>
                                                        <small class="d-block text-muted mt-1" style="font-size: 12px;">[10:30 AM]</small>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr style="transition: all 0.3s ease; border-bottom: 1px solid #f0f0f0;">
                                                <td class="py-3 align-middle">
                                                    <span class="badge" style="background: #321575; padding: 6px 14px; font-size: 0.9rem; color: white;">B</span>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #059669; font-weight: 500;">
                                                        <strong>{{ openCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #dc2626; font-weight: 500;">
                                                        <strong>{{ closeCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #1e40af; font-weight: 500;">
                                                        <strong>10 January, 2026</strong>
                                                        <small class="d-block text-muted mt-1" style="font-size: 12px;">[10:30 AM]</small>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr style="transition: all 0.3s ease; border-bottom: 1px solid #f0f0f0;">
                                                <td class="py-3 align-middle">
                                                    <span class="badge" style="background: #321575; padding: 6px 14px; font-size: 0.9rem; color: white;">B1</span>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #059669; font-weight: 500;">
                                                        <strong>{{ openCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #dc2626; font-weight: 500;">
                                                        <strong>{{ closeCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #1e40af; font-weight: 500;">
                                                        <strong>07 January, 2026</strong>
                                                        <small class="d-block text-muted mt-1" style="font-size: 12px;">[10:30 AM]</small>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr style="transition: all 0.3s ease; border-bottom: 1px solid #f0f0f0;">
                                                <td class="py-3 align-middle">
                                                    <span class="badge" style="background: #321575; padding: 6px 14px; font-size: 0.9rem; color: white;">B2</span>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #059669; font-weight: 500;">
                                                        <strong>{{ openCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #dc2626; font-weight: 500;">
                                                        <strong>{{ closeCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #1e40af; font-weight: 500;">
                                                        <strong>08 January, 2026</strong>
                                                        <small class="d-block text-muted mt-1" style="font-size: 12px;">[10:30 AM]</small>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr style="transition: all 0.3s ease; border-bottom: 1px solid #f0f0f0;">
                                                <td class="py-3 align-middle">
                                                    <span class="badge" style="background: #321575; padding: 6px 14px; font-size: 0.9rem; color: white;">C</span>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #059669; font-weight: 500;">
                                                        <strong>{{ openCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #dc2626; font-weight: 500;">
                                                        <strong>{{ closeCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #1e40af; font-weight: 500;">
                                                        <strong>09 January, 2026</strong>
                                                        <small class="d-block text-muted mt-1" style="font-size: 12px;">[10:30 AM]</small>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr style="transition: all 0.3s ease; border-bottom: 1px solid #f0f0f0;">
                                                <td class="py-3 align-middle">
                                                    <span class="badge" style="background: #321575; padding: 6px 14px; font-size: 0.9rem; color: white;">D</span>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #059669; font-weight: 500;">
                                                        <strong>{{ openCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #dc2626; font-weight: 500;">
                                                        <strong>{{ closeCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #1e40af; font-weight: 500;">
                                                        <strong>03 January, 2026</strong>
                                                        <small class="d-block text-muted mt-1" style="font-size: 12px;">[10:30 AM]</small>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr style="transition: all 0.3s ease;">
                                                <td class="py-3 align-middle">
                                                    <span class="badge" style="background: #321575; padding: 6px 14px; font-size: 0.9rem; color: white;">D1</span>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #059669; font-weight: 500;">
                                                        <strong>{{ openCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #dc2626; font-weight: 500;">
                                                        <strong>{{ closeCallDate }}</strong>
                                                    </div>
                                                </td>
                                                <td class="py-3 align-middle">
                                                    <div class="d-inline-block" style="color: #1e40af; font-weight: 500;">
                                                        <strong>05 January, 2026</strong>
                                                        <small class="d-block text-muted mt-1" style="font-size: 12px;">[10:30 AM]</small>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>

                        
                        <div class="col-12">
                            <div class="abouts center-text mt-5 p-5 bg-white" style="width:100%;border-radius: 16px;box-shadow: 0 4px 20px rgba(0,0,0,0.1);">
                                <div class="format-sub-text table-responsive" style="border-radius: 12px; overflow: hidden;">
                                    <table class="table table-hover mb-0" style="font-size: 14px;">
                                        <thead style="background: #f8fafc; color: #475569;">
                                            <tr>
                                                <th scope="col" class="py-3 align-middle text-center" style="font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; font-size: 13px;">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle; margin-right: 8px; color: #321575;">
                                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                                        <circle cx="12" cy="10" r="3"></circle>
                                                    </svg>
                                                    Exam Locations
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody class="bg-white">
                                            <tr style="transition: all 0.3s ease;">
                                                <td class="py-4 align-middle text-center">
                                                    <div style="color: #1a202c; font-weight: 500; font-size: 15px; display: flex; justify-content: space-around; align-items: center; flex-wrap: wrap; gap: 15px;">
                                                        <span>Chittagong Division</span>
                                                        <span style="color: #cbd5e0;">•</span>
                                                        <span>Dhaka Division</span>
                                                        <span style="color: #cbd5e0;">•</span>
                                                        <span>Rajshahi Division</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <!-- VC Mam Message and Importent Date Section End -->
            <!-- modal area -->
            <div>
                <!-- Registration Modal -->
                <b-modal id="registrationModal" size="lg" hide-footer>
                    <template #modal-title>
                        Student Registration - Step#1
                    </template>
                    <form v-on:submit.prevent="onRagistrationFormSubmit">
                        <div class="modal-body">
                            <div class="container padding-cls">
                                <div class="checkout-page">
                                    <div class="theme-form checkout-form-1">
                                        <div class="row center-content">
                                            <div class="col-lg-12 col-sm-12 col-xs-12 mb-3">
                                                <div class="theme-card p-3 check-out ng-star-inserted">
                                                    <div class="row">
                                                        <div class="form-group col-md-4 py-0 col-sm-6 col-xs-12">
                                                            <div class="field-label">HSC Board</div>
                                                            <select name="hscboard" v-model="registrationForm.hsc_board"
                                                                placeholder="HSC Board" autocomplete="off"
                                                                class="ng-dirty ng-valid ng-touched" required>
                                                                <option value="" selected="">Select HSC Board</option>
                                                                <option v-for="(value, name) in hscBoards" :key="name"
                                                                    :value="name" class="ng-star-inserted">{{ value }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                        <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                                            <div class="field-label">HSC Roll</div>
                                                            <input type="number" id="hscRoll"
                                                                v-on:input="checkRange('hscRoll')" step="1"
                                                                name="hscroll" value="1" placeholder="HSC Roll"
                                                                class="ng-untouched ng-pristine ng-invalid"
                                                                v-model="registrationForm.hsc_roll" min="100000"
                                                                max="999999" required>
                                                        </div>
                                                        <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                                            <div class="field-label">HSC Pass Year</div>
                                                            <select name="hscpassyear"
                                                                v-model="registrationForm.hsc_year" value=""
                                                                placeholder="HSC Pass Year" autocomplete="off"
                                                                class="ng-pristine ng-invalid ng-touched" required>
                                                                <option value="" selected="">Select HSC Pass Year
                                                                </option>
                                                                <option v-for="(value, name) in hscYears" :key="name"
                                                                    :value="value" class="ng-star-inserted">{{ value }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                        <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                                            <div class="field-label">SSC Board</div>
                                                            <select name="sscboard" value=""
                                                                v-model="registrationForm.ssc_board"
                                                                placeholder="SSC Board" autocomplete="off"
                                                                class="ng-untouched ng-pristine ng-invalid" required>
                                                                <option value="" selected="">Select SSC Board</option>
                                                                <option v-for="(value, name) in sscBoards" :key="name"
                                                                    :value="name" class="ng-star-inserted">{{ value }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                        <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                                            <div class="field-label">SSC Roll</div>
                                                            <input type="number" id="sscRoll" name="sscroll"
                                                                v-on:input="checkRange('sscRoll')"
                                                                v-model="registrationForm.ssc_roll" value=""
                                                                placeholder="SSC Roll" autocomplete="off"
                                                                class="ng-untouched ng-pristine ng-invalid" min="100000"
                                                                max="999999" required>
                                                        </div>
                                                        <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                                            <div class="field-label">SSC Pass Year</div>
                                                            <select name="sscpassyear" value=""
                                                                v-model="registrationForm.ssc_year"
                                                                placeholder="SSC Pass Year" autocomplete="off"
                                                                class="ng-untouched ng-pristine ng-invalid" required>
                                                                <option value="" selected="">Select SSC Pass Year
                                                                </option>
                                                                <option v-for="(value, name) in sscYears" :key="name"
                                                                    :value="value" class="ng-star-inserted">{{ value }}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="width:100%" v-if="!claimInvalidEnable && !claimEnable">
                                <button v-if="!rButtonLoading" class="btn info-btn btn-info radius-1" style="width:100%"
                                    type="submit" block>Submit </button>
                                <button v-else disabled class="btn info-btn btn-info radius-1" style="width:100%"
                                    type="submit" block>
                                    <i class="fa fa-spinner fa-spin"></i> Loading...
                                </button>
                            </div>
                            <div style="width:100%" v-if="claimInvalidEnable || claimEnable">
                                <div style="text-align:center;margin:auto">
                                    <button v-if="submitEnable && !rButtonLoading" style="margin-right:10px"
                                        class="btn info-btn btn-info radius-1" type="submit" block>
                                        Submit
                                    </button>
                                    <button v-if="submitEnable && rButtonLoading" disabled style="margin-right:10px"
                                        class="btn info-btn btn-info radius-1" type="submit" block>
                                        <i class="fa fa-spinner fa-spin"></i> Loading...
                                    </button>
                                    <router-link to="complain" v-if="claimEnable" class="btn info-btn btn-info radius-1"
                                        type="button" block>
                                        Complain
                                    </router-link>
                                    <button v-if="claimInvalidEnable" class="btn info-btn btn-info radius-1"
                                        type="button" @click="toClaim" block>
                                        Claim For Invalid Information
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </b-modal>

                <!-- mobile number form modal -->
                <b-modal id="mobileModal" size="md" hide-footer>
                    <template #modal-title>
                        Student Registration - Step#2
                    </template>
                    <form v-on:submit.prevent="onPhoneSubmit">
                        <div class="modal-body mx-0 px-0 text-center" >
                            <div class="container px-0 mx-0 mb-3">
                                <div class="checkout-page px-0 mx-0">
                                    <div class="checkout-form-1 checkout-form-2-height theme-form ">
                                        <div class="row center-content px-0 mx-0">
                                            <div class="col-lg-12 col-sm-12 col-xs-12">
                                                <div class="theme-card check-out ng-star-inserted">
                                                    <div class="row h-auto py-2 px-3">
                                                        <div class="form-group col-md-12 col-sm-12 col-xs-12"
                                                            style="margin-bottom:20px">
                                                            <div class="field-label text-left">Your personal mobile
                                                                number</div>
                                                            <div class="input-group flex-nowrap">
                                                                <span class="input-group-text"
                                                                    id="addon-wrapping">+88</span>
                                                                <input type="number" class="form-control mobile-input"
                                                                    name="phone" value="" placeholder="Mobile No."
                                                                    aria-label="Mobile No."
                                                                    aria-describedby="addon-wrapping" autocomplete="off"
                                                                    v-model="registrationForm.mobile" required>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button class="btn info-btn btn-info radius-1 submit-btn-1" v-if="!mButtonLoading"
                                style="width:100%" type="submit" block>
                                <i class="fa fa-paper-plane"></i>
                                Send Confirmation Code</button>
                            <button class="btn info-btn btn-info radius-1 submit-btn-1" disabled v-else
                                style="width:100%" type="submit" block><i class="fa fa-spinner fa-spin"></i>
                                Loading...</button>
                        </div>
                    </form>
                </b-modal>

                <!-- claim invalid information modal -->
                <b-modal id="claimInvalidModal" size="md" hide-footer>
                    <template #modal-title>
                        Complain For Invalid Information
                    </template>
                    <form v-on:submit.prevent="onClaimInvalid">
                        <div class="modal-body">
                            <div class="container padding-cls">
                                <div class="checkout-page">
                                    <div class="checkout-form theme-form">
                                        <div class="row center-content">
                                            <div class="col-lg-12 col-sm-12 col-xs-12">
                                                <div class="theme-card check-out ng-star-inserted">
                                                    <div class="row">
                                                        <div class="form-group col-md-12 col-sm-12 col-xs-12"
                                                            style="margin-bottom:20px">
                                                            <div class="field-label">Your personal mobile number</div>
                                                            <div class="input-group flex-nowrap">
                                                                <span class="input-group-text"
                                                                    id="addon-wrapping">+88</span>
                                                                <input type="text" class="form-control" name="phone"
                                                                    value="" placeholder="Mobile No."
                                                                    aria-label="Mobile No."
                                                                    aria-describedby="addon-wrapping" autocomplete="off"
                                                                    v-model="registrationForm.mobile" required>
                                                            </div>
                                                        </div>
                                                        <div class="form-group col-md-12 col-sm-12 col-xs-12"
                                                            style="margin-bottom:20px">
                                                            <div class="field-label">Your Complain</div>
                                                            <div class="input-group flex-nowrap">
                                                                <input type="text" class="form-control" name="complain"
                                                                    value="" placeholder="Complain"
                                                                    aria-label="Complain"
                                                                    aria-describedby="addon-wrapping" autocomplete="off"
                                                                    v-model="registrationForm.complain" required>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button class="btn info-btn btn-info radius-1" style="width:100%" type="submit"
                                block>Claim</button>
                        </div>
                    </form>
                </b-modal>

                <!-- Verification Code form Modal -->
                <b-modal id="verificationModal" size="md" hide-footer>
                    <template #modal-title>
                        Student Registration - Step#3
                    </template>
                    <form v-on:submit.prevent="onCodeSubmit">
                        <div class="container padding-cls">
                            <div class="checkout-page">
                                <div class="checkout-form-1 theme-form px-0 mx-0">
                                    <div class="row center-content px-0 mx-0" style="flex-direction: unset;">
                                        <div class="col-lg-12 col-sm-12 col-xs-12">
                                            <div class="theme-card mb-3 px-3 ng-star-inserted">
                                                <div class="row">
                                                    <div class="col-sm-12 col-12">
                                                        <div class="count text-right py-2"
                                                            style="height: 25px;font-size: 18px;float: right;padding-right: 9rem;">
                                                            <div style="position: absolute;width: 78px;">
                                                                <span id="minutes" class="days-text gradient-text">{{
                                                                    verificationCounter.mins }}</span>
                                                                <span v-if="verificationCounter.mins > 1"
                                                                    class="days gradient-text">
                                                                    minutes </span>
                                                                <span v-else class="days gradient-text"> minute </span>
                                                            </div>
                                                            <div style="position: absolute;width: 153px;">
                                                                <span id="seconds" class="days-text gradient-text">{{
                                                                    verificationCounter.seconds }}</span>
                                                                <span v-if="verificationCounter.seconds > 1"
                                                                    class="days gradient-text"> seconds</span>
                                                                <span v-else class="days gradient-text"> second</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="form-group col-md-12 col-sm-12 col-xs-12"
                                                        style="margin-bottom:20px">
                                                        <div class="field-label">Confirmation Code</div>
                                                        <input type="text" name="code" value="" placeholder="Code"
                                                            autocomplete="off"
                                                            class="ng-untouched ng-pristine ng-invalid"
                                                            v-model="registrationForm.code" required>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-around align-items-center w-full px-1 pt-2">
                            <button v-if="verifyBtn && !cButtonLoading" style="margin-right:10px"
                                class="btn info-btn btn-info radius-1" type="submit" block>
                                
                                Verify Code
                            </button>
                            <button v-if="cButtonLoading" disabled style="margin-right:10px"
                                class="btn info-btn btn-info radius-1" type="button" block>
                                <i class="fa fa-spinner fa-spin"></i> Loading...
                            </button>
                            <button v-if="verifyResendBtn && !resendVerComplete" class="btn info-btn btn-info radius-1"
                                type="button" @click="codeResend" block>
                                <i class="fa fa-refresh"></i>
                                Re-Send
                            </button>
                            <button class="btn primary-btn btn-secondary radius-1" @click="$bvModal.show('mobileModal')"
                                style="float:right" type="button" block>
                                <!-- Go back icon -->
                                <i class="fa fa-arrow-left"></i>
                                Go Back
                            </button>
                        </div>
                    </form>
                </b-modal>

                <!-- complete registration message and other message text show modal -->
                <b-modal id="completeModal" size="lg" hide-footer>
                    <template #modal-title>
                        {{ registrationStatus }}
                    </template>
                    <h4 style="text-transform: unset;" align="center" class="text-success" v-if="registrationComplete">
                        Your registration has been successfully completed.<br>
                        Please check your mobile for username and password.<br>
                        <a @click="resendUsernameAndPassword()" v-if="!resendUsernamePass"
                            style="color: #8797a5;font-size:20px">Resend
                            my Username & Password</a>
                    </h4>
                    <b-button class="mt-3" v-if="registrationComplete" @click="goForLogin()" block>Click here to
                        Login</b-button>
                    <b-button class="mt-3" v-else @click="$bvModal.hide('completeModal')" block>Ok</b-button>
                </b-modal>
                <!-- login modal -->
                <b-modal id="loginModal" size="md" hide-footer>
                    <template #modal-title>
                        Log In
                    </template>
                    <!-- login component call -->
                    <login @goForPasswordRecovery="goForPasswordRecovery"></login>
                </b-modal>
                <b-modal id="password-recovery-modal" size="md" hide-footer>
                    <template #modal-title>
                        Password Recovery
                    </template>
                    <!-- password recovery component call -->
                    <!-- Basic Changes to link with Jira Item -->
                    <passwordRecovery @goForLogin="goForLogin"></passwordRecovery>
                </b-modal>
            </div>
            <!-- modal div end -->
            <!-- counter start -->
            <!-- <section class="event counter set-relative bg bg-img3 bg-about bg-about-counter" style="padding:40px 0px" v-if="showCntDownMsg">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-12 counter-container">
                            <div class="counters">
                                <div class="counter-text p-4">
                                    <h4 class="count-desc text-center text-white">{{applicationLastDateMessage}}
                                        </h4>
                                </div>
                                <img src="../../theme-assets/images/event/counter/3.png" alt="" class="img-fluid counter-img">
                                <div class="counter-text p-2">
                                    <h2 class="count-number text-center text-white counts">
                                        <span class="counter">{{applicationLastDate}}</span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-12 counter-container">
                            <div class="counters">
                                <div class="center-text">
                                    <div class="text-center w-100 pt-5">
                                        <div class="wedding-time">
                                            <div class="row pt-2">
                                                <div class="col-sm-3 col-6">
                                                    <div class="event-content wedding-content">
                                                        <div class="count">
                                                            <div class="counter-container">
                                                                <h2 class="text-white text-right">
                                                                    <span id="days" class="days-text">{{counter.days}}</span>
                                                                    <span class="days gradient-text">days</span>
                                                                </h2>
                                                            </div>
                                                            <div class="set-border-left">
                                                            </div>
                                                            <div class="set-border-bottom">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3 col-6">
                                                    <div class="event-content wedding-content">
                                                        <div class="count">
                                                            <div class="counter-container">
                                                                <h2 class="text-white text-right">
                                                                    <span id="hours" class="days-text gradient-text">{{counter.hours}}</span>
                                                                    <span class="days gradient-text">hours</span>
                                                                </h2>
                                                            </div>
                                                            <div class="set-border-left"></div>
                                                            <div class="set-border-bottom"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3 col-6">
                                                    <div class="event-content wedding-content">
                                                        <div class="count">
                                                            <div class="counter-container">
                                                                <h2 class="text-white text-right">
                                                                    <span id="minutes" class="days-text gradient-text">{{counter.mins}}</span>
                                                                    <span class="days gradient-text"> minutes</span>
                                                                </h2>
                                                            </div>
                                                            <div class="set-border-left"></div>
                                                            <div class="set-border-bottom"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3 col-6">
                                                    <div class="event-content wedding-content">
                                                        <div class="count">
                                                            <div class="counter-container">
                                                                <h2 class="text-white text-right">
                                                                    <span id="seconds" class="days-text gradient-text">{{counter.seconds}}</span>
                                                                    <span class="days gradient-text">seconds</span>
                                                                </h2>
                                                            </div>
                                                            <div class="set-border-left"></div>
                                                            <div class="set-border-bottom"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
            <!--counter section end-->
        </div>
        <!-- Show maintenance mode when: not loading AND maintenance started AND not yet ended -->
        <div v-else-if="!loading && openSystemMaintenance && !closeSystemMaintenance">
            <maintenance-mode/>
        </div>
        <!-- Show loader while loading -->
        <div v-else-if="loading">
            <loader class="loader"></loader>
        </div>
        <div class="tap-top">
            <div><i v-on:click="topFunction()" class="fa fa-angle-double-up"></i></div>
        </div>
    </div>
</template>

<script>
import Loader from '../Helper/Loader'
import Login from '../Auth/Login'
import PasswordRecovery from '../Auth/PasswordRecovery'
import '@/assets/css/checkout-form-new.css'
import RegistrationCountDown from './RegistrationCountDown'

import {
    HOME_PAGE_INFO,
    REGISTRATION,
    SEND_CONFIRMATION_CODE,
    RESEND_CONFIRMATION_CODE,
    VERIFY_CONFIRMATION_CODE,
    CLAIM_STUDENT_REQUEST,
    GET_HSC_BOARDS,
    GET_SSC_BOARDS,
    GET_YEARS
} from '../../const/api'
import { GET, POST } from '../../utils/Request'
import MaintenanceMode from './MaintenanceMode.vue'
export default {
    name: 'HomePage',
    components: { Loader, Login, PasswordRecovery, RegistrationCountDown, MaintenanceMode },
    data() {
        return {
            loading: true,
            firstTimeLoad: true,
            rButtonLoading: false,
            mButtonLoading: false,
            vButtonLoading: false,
            cButtonLoading: false,
            registrationStatus: '',
            sitePhase: 0,
            counter: {
                days: 0,
                hours: 0,
                mins: 0,
                seconds: 0
            },
            verificationCounter: {
                mins: 0,
                seconds: 0
            },
            verificationTimer: null,
            registrationForm: {
                hsc_board: '',
                hsc_roll: '',
                hsc_year: '',
                ssc_board: '',
                ssc_roll: '',
                ssc_year: '',
                mobile: '',
                code: '',
                complain: ''
            },
            scroll_news: '',
            /*Application open or close*/
            applicationOpen: false,
            /*Application Process open or close*/
            openCall: false,
            /*Application Process toally close*/
            closeCall: false,
            /*If application totally closed than shows this message*/
            openCallMsg: '',
            closeCallRemark: '',
            openCallDate: '',
            closeCallDate: '',

            openCallPayment: false,
            closeCallPayment: false,
            closeCallPaymentRemark: '',

            openCorrectionPayment: false,
            closeCorrectionPayment: false,
            openCallPaymentDate: '',
            closeCallPaymentDate: '',
            openCorrectionPaymentDate: '',
            closeCorrectionPaymentDate: '',
            openSystemMaintenance: false,

            openAdmitCard: false,
            closeAdmitCard: false,
            openAdmitCardDate: [],
            closeAdmitCardRemark: '',
            detailAdmitCardDates: [],

            openExam: false,
            closeExam: false,
            openExamDate: [],
            detailExamDates: [],

            /*countDown message*/
            showCntDownMsg: true,
            applicationLastDateMessage: '',
            applicationLastDate: '',
            claimEnable: false,
            claimInvalidEnable: false,

            sscBoards: null,
            hscBoards: null,
            sscYears: null,
            hscYears: null,

            /*Resend limitation over or not*/
            resendVerComplete: false,

            sscBoards: null,
            hscYear: '',
            sscYear: '',
            /*Submit Registration form enable of not*/
            submitEnable: true,
            /*Registration process complete or not*/
            registrationComplete: false,
            /*verification resend button will show or not*/
            verifyResendBtn: false,
            /*Submit verification code enable or not*/
            verifyBtn: true,
            /*resend username or password enable or not*/
            resendUsernamePass: false,
            /*link to show guidline*/
            GCE_EquivalentGuideline: '',
            scroll_news: ''
        }
    },
    computed: {
        isOnHomepage() {
            let routeName = this.$route.name
            return routeName == 'home' ? true : false
        },
        appEnv() {
            return process.env.VUE_APP_ENV || 'production'
        }
    },
    created() {
        this.getAllAdminSettingsData();
        this.timeoutForLoading();

        this.getHSCBoard();
    },
    methods: {

        async resendUsernameAndPassword() {
            this.resendUsernamePass = true;
            let response = await POST(VERIFY_CONFIRMATION_CODE, this.registrationForm);
            if (response.status == '200') {
                let type = response.data.type;
                let msg = response.data.msg;
                if (type == 'success') {
                    this.$iziToast.success({
                        message: msg
                    });
                } else {
                    if (type == 'info') {
                        this.$iziToast.info({
                            message: msg
                        });
                    } else {
                        this.$iziToast.error({
                            message: msg
                        });
                    }
                }
            } else {
                this.$iziToast.error({
                    message: 'Something Went Wrong. Please try again.'
                });
            }
        },
        /*Check number range for cusmot message*/
        checkRange(id) {
            var input = document.getElementById(id);
            input.setCustomValidity("");
            if (input.validity.rangeOverflow) {
                input.setCustomValidity("Please Enter 6 digit Number.");
            } else if (input.validity.rangeUnderflow) {
                input.setCustomValidity("Please Enter 6 digit Number.");
            }
        },
        clearForm() {
            this.registrationForm.hsc_board = '';
            this.registrationForm.hsc_roll = '';
            this.registrationForm.hsc_year = '';
            this.registrationForm.ssc_board = '';
            this.registrationForm.ssc_roll = '';
            this.registrationForm.ssc_year = '';
            this.registrationForm.mobile = '';
            this.registrationForm.code = '';
            this.submitEnable = true;
            this.claimInvalidEnable = false;
            this.registrationComplete = false;
        },

        async getAllAdminSettingsData() {
            try {
                var data = await GET(HOME_PAGE_INFO);

                // console.log('getAllAdminSettingsData', data.data);

                this.scroll_news = data.data.scroll_news;

                this.applicationOpen = !data.data.closeCall && data.data.openCall;

                /*If openCall = true and closeCall = false Rgistration Button Show*/
                /*If openCall = true and closeCall = true Rgistration Button Hide*/
                /*If openCall = false show openCallMeg insteed of buttons*/

                this.openCall = data.data.openCall;
                this.openCallDate = data.data.openCallDate;
                this.openCallMsg = data.data.openCallMsg;
                this.closeCall = data.data.closeCall;
                this.closeCallDate = data.data.closeCallDate;
                this.closeCallRemark = data.data.closeCallRemark;

                this.openCallPayment = data.data.openCallPayment;
                this.openCallPaymentDate = data.data.openCallPaymentDate;
                this.closeCallPayment = data.data.closeCallPayment;
                this.closeCallPaymentDate = data.data.closeCallPaymentDate;

                this.openCorrectionPayment = data.data.openCorrectionPayment;
                this.openCorrectionPaymentDate = data.data.openCorrectionPaymentDate;
                this.closeCorrectionPayment = data.data.closeCorrectionPayment;
                this.closeCorrectionPaymentDate = data.data.closeCorrectionPaymentDate;

                this.openAdmitCard = data.data.openAdmitCard;
                this.closeAdmitCard = data.data.closeAdmitCard;
                this.openAdmitCardDate = data.data.openAdmitCardDate;
                this.closeAdmitCardRemark = data.data.closeAdmitCardRemark;
                this.detailAdmitCardDates = data.data.detailAdmitCardDates;

                this.openExam = data.data.openExam;
                this.closeExam = data.data.closeExam;
                this.openExamDate = data.data.openExamDate;
                this.detailExamDates = data.data.detailExamDates;

                this.openSystemMaintenance = data.data.openSystemMaintenance === true
                this.closeSystemMaintenance = data.data.closeSystemMaintenance === true

                this.sitePhase = data.data.sitePhase;

                console.log(data.data)

                if (data.data.openCallMsg != null) {
                    this.openCallMsg = data.data.openCallMsg;
                } else {
                    this.openCallMsg = 'Application Will be Open Soon';
                }

                this.showCntDownMsg = data.data.showCntDownMsg;
                this.applicationLastDateMessage = data.data.cntDownMsg;
                let date = data.data.cntDownDate.split(' ');
                this.applicationLastDate = date[0];
            } catch (e) {
                /*console.log(e);*/
                this.loading = false
            }
        },

        async getHSCBoard() {
            // console.log("getHSCBoard : ");
            var data = await GET(GET_HSC_BOARDS);
            this.hscBoards = data.data;

            await this.getSSCBoard();
            await this.getYears();

            /*this.getSSCBoard();
            this.getYears();*/

            // console.log("getHSCBoard : ", this.hscBoards);
        },
        async getSSCBoard() {
            var data = await GET(GET_SSC_BOARDS);
            this.sscBoards = data.data;
            // console.log("getSSCBoard : ", this.sscBoards);
        },
        async getYears() {
            var data = await GET(GET_YEARS);
            this.sscYears = data.data.ssc_year;
            this.hscYears = data.data.hsc_year;
            this.registrationForm.hsc_year = this.hscYear;
            this.registrationForm.ssc_year = this.sscYear;

            /*console.log("getYears HSC : ", this.hscYears);*/
            /*console.log("getYears SSC : ", this.sscYears);*/
        },

        async onRagistrationFormSubmit(event) {
            this.rButtonLoading = true;
            this.registrationStatus = '';
            event.preventDefault();
            if (this.registrationForm.mobile == '') {
                this.registrationForm.mobile = '+88';
            }
            let response = await POST(REGISTRATION, this.registrationForm);
            // console.log('registration-step#1', this.registrationForm, response.data.msg);

            if (this.registrationForm.mobile == '+88') {
                this.registrationForm.mobile = '';
            }
            if (response.status == '200') {
                let type = response.data.type;
                let msg = response.data.msg;
                let code = response.data.code;
                if (type == 'success') {
                    this.$bvModal.hide('registrationModal');
                    this.$iziToast.success({
                        message: msg
                    });
                    this.$bvModal.show('mobileModal');
                } else if (type == 'info') {
                    this.$iziToast.info({
                        message: msg
                    });
                } else {
                    this.$iziToast.error({
                        message: msg
                    });
                }
                if (code == 916) {
                    this.claimInvalidEnable = true;
                } else if (code == 914 || code == 913) {
                    this.claimEnable = true;
                } else {
                    this.claimInvalidEnable = false;
                    this.claimEnable = false;
                }
            } else {
                this.$iziToast.error({
                    message: 'Something went wrong. Please Try Again.'
                });
            }
            this.rButtonLoading = false;
        },

        async onClaim(event) {
            this.registrationStatus = '';
            event.preventDefault();
            let response = await POST(CLAIM_STUDENT_REQUEST, this.registrationForm);
            if (response.status == '200') {
                let type = response.data.type;
                let msg = response.data.msg;
                if (type == 'success') {
                    this.$bvModal.hide('registrationModal');
                    this.$iziToast.success({
                        message: msg
                    });
                    this.$bvModal.show('mobileModal');
                } else {
                    if (type == 'info') {
                        this.$iziToast.info({
                            message: msg
                        });
                    } else {
                        this.$iziToast.error({
                            message: msg
                        });
                    }
                    this.clearForm();
                }
            } else {
                this.$iziToast.error({
                    message: 'Something Went Wrong. Please try again.'
                });

            }
        },
        toClaim() {
            this.submitEnable = false;
            this.$bvModal.show('claimInvalidModal');
        },
        async onClaimInvalid(event) {
            this.registrationStatus = '';
            event.preventDefault();
            let response = await POST(CLAIM_STUDENT_REQUEST, this.registrationForm);
            if (response.status == '200') {
                let type = response.data.type;
                let msg = response.data.msg;
                if (type == 'success') {
                    this.$bvModal.hide('claimInvalidModal');
                    this.$bvModal.hide('registrationModal');
                    this.registrationStatus = msg;
                    this.$bvModal.show('completeModal');
                    this.$iziToast.success({
                        message: msg
                    });
                    this.clearForm();
                } else {
                    if (type == 'info') {
                        this.$iziToast.info({
                            message: msg
                        });
                    } else {
                        this.$iziToast.error({
                            message: msg
                        });
                    }
                }
            } else {
                this.$iziToast.error({
                    message: 'Something Went Wrong. Please try again.'
                });
            }
        },

        async onPhoneSubmit(event) {
            event.preventDefault();
            this.mButtonLoading = true;
            let response = null;
            if (this.resendVerComplete) {
                response = await POST(RESEND_CONFIRMATION_CODE, this.registrationForm);
                if (response.data.data) {
                    if (response.data.data.resend_button) {
                        this.resendVerComplete = false;
                    }
                }
            } else {
                response = await POST(SEND_CONFIRMATION_CODE, this.registrationForm);
            }
            if (response.status == '200') {
                let type = response.data.type;
                let code = response.data.code;
                let msg = response.data.msg;
                if (type == 'success') {
                    this.$iziToast.success({
                        message: msg
                    });
                    this.$bvModal.hide('mobileModal');
                    this.setVerificationTimer(2);
                    this.$bvModal.show('verificationModal');
                } else {
                    if (type == 'info') {
                        this.$iziToast.info({
                            message: msg
                        });
                    } else {
                        this.$iziToast.error({
                            message: msg
                        });
                    }
                    /*904 for this user already registered*/
                    if (code == '904') {
                        this.$bvModal.hide('mobileModal');
                        this.setVerificationTimer(2);
                        this.$bvModal.show('verificationModal');
                    }

                }
            } else {
                this.$iziToast.error({
                    message: 'Something Went Wrong. Please try again.'
                });
            }
            this.mButtonLoading = false;
        },

        async onCodeSubmit(event) {
            this.cButtonLoading = true;
            event.preventDefault();
            let response = await POST(VERIFY_CONFIRMATION_CODE, this.registrationForm);
            if (response.status == '200') {
                let type = response.data.type;
                let msg = response.data.msg;
                if (type == 'success') {
                    this.registrationStatus = 'Congratulation!';
                    this.$bvModal.hide('verificationModal');
                    this.registrationComplete = true;
                    this.verifyResendBtn = false;
                    this.verifyBtn = true;
                    this.$iziToast.success({
                        message: msg
                    });
                    this.$bvModal.show('completeModal');
                } else {
                    if (type == 'info') {
                        this.$iziToast.info({
                            message: msg
                        });
                    } else {
                        this.$iziToast.error({
                            message: msg
                        });
                    }
                }
            } else {
                this.$iziToast.error({
                    message: 'Something Went Wrong. Please try again.'
                });
            }
            this.cButtonLoading = false;
        },

        codeResend() {
            this.$bvModal.hide('verificationModal');
            this.resendVerComplete = true;
            this.verifyBtn = true;
            this.$bvModal.show('mobileModal');
        },

        /*set verification timer*/
        setVerificationTimer(timeInMin) {
            "use strict";
            let globalThis = this;
            let timeInSecond = timeInMin * 60;
            if (this.verificationTimer != null) {
                clearInterval(this.verificationTimer);
                this.verificationTimer = null;
                this.verificationCounter.mins = 0;
                this.verificationCounter.seconds = 0;
            }

            this.verificationTimer = setInterval(function () {
                let mins = Math.floor(timeInSecond / 60);
                let seconds = Math.floor(timeInSecond % 60);
                globalThis.verificationCounter.mins = mins;
                globalThis.verificationCounter.seconds = seconds;
                if (timeInSecond <= 0) {
                    globalThis.verifyBtn = true;
                    if (!globalThis.resendVerComplete)
                        globalThis.verifyResendBtn = true;
                    else {
                        globalThis.$bvModal.hide('verificationModal');
                        globalThis.$iziToast.error({
                            message: 'Your verification timeout.'
                        });
                    }
                    clearInterval(globalThis.verificationTimer);
                    globalThis.verificationTimer = null;
                    globalThis.verificationCounter.mins = 0;
                    globalThis.verificationCounter.seconds = 0;
                } else {
                    timeInSecond--;
                }
            }, 1000);

        },

        /*Set countdown*/
        setTimer(dateTime) {
            "use strict";
            let globalThis = this;
            const second = 1000,
                minute = second * 60,
                hour = minute * 60,
                day = hour * 24;
            let dateParts = dateTime.split("/");
            let yearAndTime = dateParts[2].split(" ");
            let time = yearAndTime[1].split(':');
            let countDown;
            countDown = new Date(yearAndTime[0] + '-' + dateParts[1] + '-' + dateParts[0] + 'T' + time[0] + ':' + time[1] + ':' + time[2]).getTime();
            let x = setInterval(function () {
                let now = new Date().getTime(),
                    distance = countDown - now;
                let days = Math.floor(distance / (day));

                let hours = Math.floor((distance % (day)) / (hour));
                let mins = Math.floor((distance % (hour)) / (minute));
                let seconds = Math.floor((distance % (minute)) / second);

                if (globalThis.counter.days != days) {
                    globalThis.counter.days = days;
                }
                if (globalThis.counter.hours != hours) {
                    globalThis.counter.hours = hours;
                }
                if (globalThis.counter.mins != mins) {
                    globalThis.counter.mins = mins;
                }

                globalThis.counter.seconds = seconds;
            }, second);
        },

        goForUrl(url) {
            this.$router.replace(url)
        },
        goForLogin() {
            this.$bvModal.hide('password-recovery-modal');
            this.$bvModal.hide('completeModal');
            this.$bvModal.show('loginModal');
        },
        goForPasswordRecovery() {
            this.$bvModal.hide('loginModal');
            this.$bvModal.show('password-recovery-modal');
        },
        topFunction() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
        timeoutForLoading() {
            if (this.firstTimeLoad) {
                this.$nextTick(() => {
                    setTimeout(
                        function () {
                            this.loading = false
                        }.bind(this),
                        1000
                    )
                })
            }
            this.firstTimeLoad = false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
    margin-top: 20%;
}

.kalpurush {
    font-family: "kalpurush", Helvetica, Arial;
}
.bg-img-1{
    background: url('../../theme-assets/images/event/cu_front_gate.jpg');
    background-size: cover;
}
.event.bg-about::before{
    background-image: linear-gradient(#71afc7, #212121);
    top: 0;
    left: 0;
    opacity: 0.4 !important;
    height: 100%;
    width: 100%;
    position: absolute;
}
.home-page {
    background: url(../../assets/bg.svg);
    background-size: cover;
    /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
    padding: 5px 0px;
}

/* Header */

.header {
    /* background-image: url('../../assets/header-banner.jpg'); */
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    position: relative;
    display: table;
    width: 100%;
    height: 100vh;
}

.img-fluid {
    max-width: 100%;
}

.header .overlay {
    background-color: rgba(0, 0, 0, 0.47);
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}

.header .header-content-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.header .header-content-wrapper .header-content {
    /* background-image: url('../../assets/header_title_bg.png'); */
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    color: #292b5b;
    font-weight: 600;
    padding: 5px 5px;
}

.header-content .header-logo {
    margin-bottom: 15px;
    width: 125px;
}

.header-content .welcome-text {
    padding: 0px 95px;
    font-weight: bold;
    color: white;
}

.header-content .highlight {
    /* background-image: url('../../assets/header_title_bg_2.png'); */
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    color: #f9f142;
    display: block;
    font-size: 35px;
    margin-top: 15px;
    padding: 20px 0px;
}

.header .overlay-2 {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.4);
    color: #fff;
    font-weight: 700;
    letter-spacing: 1px;
    padding-top: 10px;
}

.header .overlay-2 .highlight {
    color: #fbf574;
    font-size: 28px;
    font-weight: 500;
}

.header .overlay-2 img {
    position: absolute;
    right: 10%;
    bottom: 0;
}

/* advantages */
.advantages {
    -webkit-box-shadow: 0px 3px 10px 0px #dadada;
    -moz-box-shadow: 0px 3px 10px 0px #dadada;
    box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
    background: rgba(245, 222, 179, 0.5);
    margin: 4px;
    padding: 8px;
}

.header .center-text {
    height: unset;
}

.header .bg {
    height: unset;
}

.header[data-v-af5e64f8] {

    height: unset;
}

* {
    box-sizing: border-box;
}

.modern-btn {
  font-family: 'kalpurush';
  font-weight: 600;
  font-size: 1.1rem;        /* bigger text */
  padding: 12px 28px;       /* bigger buttons */
  border-radius: 12px;      /* rounded edges */
  color: rgb(128, 0, 0);       
  border: 2px solid rgb(128, 0, 0);
  background-color: #ffffff;
  transition: all 0.3s ease;
}

.modern-btn:hover {
background: rgb(128, 0, 0) !important; /* cyan background on hover */
  color: #ffffff;             /* text becomes white */
  transform: translateY(-2px); /* subtle lift effect */
  box-shadow: 0 4px 15px rgba(167, 13, 13, 0.473); /* soft shadow */
}



@-webkit-keyframes ticker {
    0% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
        visibility: visible;
    }

    100% {
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
    }
}

@keyframes ticker {
    0% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
        visibility: visible;
    }

    100% {
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
    }
}

.ticker-wrap {
    /* position: fixed; */
    /* bottom: 0; */
    position: relative;
    width: 100%;
    overflow: hidden;
    height: 3rem;
    background-color: rgba(0, 0, 0, 0.9);
    padding-left: 100%;
    box-sizing: content-box;
}

.ticker-wrap .ticker {
    display: inline-block;
    height: 3rem;
    line-height: 3rem;
    white-space: nowrap;
    padding-right: 100%;
    box-sizing: content-box;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    -webkit-animation-name: ticker;
    animation-name: ticker;
    -webkit-animation-duration: 30s;
    animation-duration: 30s;
}

.ticker-wrap .ticker__item {
    display: inline-block;
    padding: 0 1.5rem;
    font-size: 1.5rem;
    color: white;
}
</style>
